const routes = [
    {
        path: "/library/holiday",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "libraryholiday_index"
        }
    }
]

export default routes;
